import type { TrackingCategory } from 'modules/tracking/UAEventTracking';
import { firstCharacterToLower } from 'modules/helpers/strings';
import type { UATrackingProps, EventParamDecorated } from '../types';
import eventCategoryToContext from './eventCategoryToContext';
import getProductListParams from './getProductListParams';
import getBrandClubPowerstepParams from './getBrandClubPowerstepParams';
import getRecommendationParams from './getRecommendationParams';

function getParams(eventCategory: TrackingCategory, label?: string): EventParamDecorated[] | undefined {
    const categoryType: Uncapitalize<TrackingCategory> = firstCharacterToLower(eventCategory);

    switch (categoryType) {
        case 'productList':
            return [...getProductListParams()];
        case 'productPage':
            return [];
        case 'basketRecomendation':
            return getRecommendationParams(label, 'basket');
        case 'cmsPageRecomendation':
            return getRecommendationParams(label, 'cms_page');
        case 'powerstep':
            return getRecommendationParams(label, 'powerstep');
        case 'powerstepAfterBasket':
            return getRecommendationParams(label, 'powerstep_after_basket');
        case 'productGroupRecomendation':
            return getRecommendationParams(label, 'product_group');
        case 'productRecomendation':
            return getRecommendationParams(label, 'product_page');
        case 'receiptPageRecommendation':
            return getRecommendationParams(label, 'receipt_page');
        case 'searchResultPageRecomendation':
        case 'zeroResultPageRecomendation':
            return getRecommendationParams(label, 'search_result_page');
        case 'bestMatch':
        case 'visualSearchResults':
            return [{ param_name: 'search_type', param_value: 'visual_search' }];
        case 'crossSell':
            return [{ param_name: 'is_cross_sell', param_value: true }];
        case 'productSlider':
            return [];
        case 'productRegime':
            return [{ param_name: 'is_regime', param_value: true }];
        case 'replenish':
            return [{ param_name: 'is_replenish', param_value: true }];
        case 'samples':
            return [{ param_name: 'is_sample', param_value: true }];
        case 'brandClubPowerstep':
            return getBrandClubPowerstepParams(label);
        case 'none':
        default:
            return undefined;
    }
}

export default function addToCartTypeEventCategoryMapper(
    eventCategory: TrackingCategory,
    eventLabel?: string
): UATrackingProps {
    const context = eventCategoryToContext(eventCategory);
    const eventParams = getParams(eventCategory, eventLabel);

    const trackingObj: UATrackingProps = {
        eventName: 'add_to_cart',
        category: 'ecommerce'
    };

    if (context) {
        trackingObj.context = context;
    }

    if (eventParams) {
        trackingObj.eventParams = eventParams;
    }

    return trackingObj;
}
